import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { instances } from '@/services/http';
import type { UploadedFile } from '@/composables/useUgcFileUpload';

type AddProofPayload = {
  userChallengeId: number;
  textProof?: string;
  linkProofUrl?: string;
  fileKeys?: UploadedFile[];
};

export const useAddProof = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: AddProofPayload) => {
      const normalizeUrlForSubmission = (value?: string) => {
        const trimmedValue = value?.trim();
        if (!trimmedValue) return undefined;
        return /^https?:\/\//i.test(trimmedValue)
          ? trimmedValue
          : `https://${trimmedValue}`;
      };

      const response = await instances.userDashboard.put(
        `challenges/${data.userChallengeId}/proof`,
        {
          textProof: data.textProof?.trim() || undefined,
          linkProofUrl: normalizeUrlForSubmission(data.linkProofUrl),
          fileKeys: data.fileKeys?.length ? data.fileKeys : undefined,
        }
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.refetchQueries(['challenges'] as any);
    },
  });
};
